import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import App from '../components/app';
import Dashboard from '../components/dashboard/dashboard';
import Deployments from '../components/deployments/fw/deployments';
import Ai_Deployments from '../components/deployments/ai/deployments';
import Devices from '../components/devices/devices';
import Artifacts from '../components/artifacts/fw/artifacts';
import Containers from '../components/artifacts/ai/containers';
import Login from '../components/user-management/login';
import Settings from '../components/settings/settings';
import Help from '../components/help/help';
import Configurations from '../components/configurations/configurations';
import SystemAdmin from '../components/system-admin/systemadmin';
import SysadmDashboard from '../components/sysadm-dashboard/dashboard';
import About from '../components/about/About';
import Signup from '../components/user-management/signup';
import Password from '../components/user-management/password';
import Preferences from '../components/preferences/preferences';
import VerifyEmail from '../components/user-management/verify-email';
import Infrastructure from '../components/infrastructure/infrastructure';
import passwordreset from '../components/user-management/passwordreset';

import { isLoggedIn } from '../auth';
import { AppContext } from '../contexts/app-context';

import { getUserRoleFromJWT } from '../helpers';
import VcamsTab from '../components/vcams/vcams-tab';
import Cameras from '../components/cameras/cameras';
import EventsAndMetrics from '../components/eventsAndMetrics/eventsAndMetrics';

const PrivateRoute = ({ component: Component, ...rest }) => {
  // if not logged in, redirect to login screen
  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn() ? (<Component {...props} {...rest} />) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

const roleBasedRoutes = (docsVersion, artifactProgress, version, aiArtifactProgress, redirect) => {
  const currentUserRole = getUserRoleFromJWT();
  if (currentUserRole === 'systemadm') {
    return (
      <Switch>
        <PrivateRoute exact path="/" component={SysadmDashboard} />
        <Route path="/system-admin/:tab?" component={SystemAdmin} />
        <PrivateRoute path="/settings/:section?" component={Settings} />
        <PrivateRoute path="/help" component={Help} docsVersion={docsVersion} version={version} />
        <PrivateRoute path="/about" component={About} docsVersion={docsVersion} version={version} />
        <Route path="/login" component={Login} />
        <PrivateRoute component={SysadmDashboard} />
      </Switch>
    );
  } else if (currentUserRole === 'viewer') {
    return (
      <Switch>
        <PrivateRoute exact path="/" component={Dashboard} />
        <PrivateRoute path="/devices/:status(pending|preauthorized|rejected|history|add)?/:filters?" component={Devices} />
        <PrivateRoute path="/deployments/:tab?" component={Deployments} docsVersion={docsVersion} />
        <PrivateRoute path="/configurations/:tab?" component={Configurations} />
        <PrivateRoute path="/settings/:section?" component={Settings} />
        <PrivateRoute path="/help" component={Help} docsVersion={docsVersion} version={version} />
        <PrivateRoute path="/about" component={About} docsVersion={docsVersion} version={version} />
        <PrivateRoute path="/vcam" component={VcamsTab} />
        <PrivateRoute path="/infrastructures" component={Infrastructure} />
        <PrivateRoute path="/cameras" component={Cameras} />
        <PrivateRoute path="/events&metrics" component={EventsAndMetrics} />
        <Route path="/login" component={Login} />
        <PrivateRoute component={Dashboard} />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <PrivateRoute exact path="/" component={Dashboard} />
        <PrivateRoute path="/devices/:status(pending|preauthorized|rejected|history|add)?/:filters?" component={Devices} redirect={redirect} />
        <PrivateRoute path="/releases/:artifactVersion?" component={Artifacts} artifactProgress={artifactProgress} />
        <PrivateRoute path="/containers/:artifactVersion?" component={Containers} aiArtifactProgress={aiArtifactProgress} />
        <PrivateRoute path="/deployments/:tab?" component={Deployments} docsVersion={docsVersion} />
        <PrivateRoute path="/aideployments/:tab?" component={Ai_Deployments} docsVersion={docsVersion} />
        <PrivateRoute path="/configurations/:tab?" component={Configurations} />
        <PrivateRoute path="/settings/:section?" component={Settings} />
        <PrivateRoute path="/help" component={Help} docsVersion={docsVersion} version={version} />
        <PrivateRoute path="/about" component={About} docsVersion={docsVersion} version={version} />
        <PrivateRoute path="/preferences/:tab?" component={Preferences} />
        <PrivateRoute path="/vcam" component={VcamsTab} redirect={redirect} />
        <PrivateRoute path="/infrastructures" component={Infrastructure} redirect={redirect} />
        <PrivateRoute path="/cameras" component={Cameras} redirect={redirect} />
        <PrivateRoute path="/events&metrics" component={EventsAndMetrics} />
        <Route path="/login" component={Login} />
        <PrivateRoute component={Dashboard} />
      </Switch>
    );
  }
};

export const publicRoutes = () => {
  return (
    <Switch>
      <Route exact path="/password-reset" component={passwordreset} />
      <Route exact path="/password" component={Password} />
      <Route path="/signup" component={Signup} />
      <Route path="/verify-email" component={VerifyEmail} />
      <Route path="/login" component={Login} />
      <Route path="/" component={Login} />
    </Switch>
  );
};

export default (
  <App>
    <AppContext.Consumer>
      {({ docsVersion, artifactProgress, version, aiArtifactProgress, redirect }) => {
        return roleBasedRoutes(docsVersion, artifactProgress, version, aiArtifactProgress, redirect);
      }}
    </AppContext.Consumer>
  </App>
);
